export class EmployeeRoomAdd {
    roomIds: number[];
    employeeId: number;
}
